import React from 'react';
import { OnboardingFieldGuide } from './OnboardingFieldGuide';
import { inventoryFieldGuideConfig } from './onboardingFieldConfigs';

/**
 * Step 1 sub-flow: walks the user field-by-field through the real green-bean
 * inventory creation form. Delegates all rendering and logic to the generic
 * OnboardingFieldGuide, configured with the inventory-specific field list.
 */
export const OnboardingInventoryFieldGuide: React.FC<{ onSkip: () => void }> = ({ onSkip }) => {
  return <OnboardingFieldGuide config={inventoryFieldGuideConfig} onSkip={onSkip} />;
};
